import { PORTFOLIOS_GET } from '../actions/types';

const initialState = {
  items: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PORTFOLIOS_GET._SUCCESS: {
      const { portfolios } = action.payload;
      state.items = portfolios;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as portfolios };
